import { Component } from "@angular/core";
import {Router} from "@angular/router";
import {BASE_CONSTANTS} from "@tci/common";

@Component({
    selector: "empty",
    templateUrl: "./ng-empty.component.html"
})
export class NgEmptyComponent {

    constructor(private router: Router) {
    }

    redirectTo() {
        this.router.navigate([BASE_CONSTANTS.APPLICATIONS]);
    }
}
